import React from 'react';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, TextField } from '@mui/material';
type TranslateFn = (key: string, params?: Record<string, unknown>) => string;

interface EditNotesDialogProps {
    open: boolean;
    value: string;
    onChange: (value: string) => void;
    onClose: () => void;
    onSave: () => void;
    isLoading: boolean;
    t: TranslateFn;
}

export const EditNotesDialog: React.FC<EditNotesDialogProps> = ({ open, value, onChange, onClose, onSave, isLoading, t }) => (
    <Dialog open={open} onClose={() => !isLoading && onClose()} maxWidth="sm" fullWidth>
        <DialogTitle>{t('places.modals.editDescription.title')}</DialogTitle>
        <DialogContent>
            <TextField
                fullWidth
                multiline
                rows={6}
                label={t('places.fields.description.label')}
                value={value}
                onChange={e => onChange(e.target.value)}
                disabled={isLoading}
                sx={{ mt: 1 }}
                helperText={t('places.modals.editDescription.characterCount', { count: value.length })}
            />
        </DialogContent>
        <DialogActions>
            <Button onClick={onClose} disabled={isLoading}>
                {t('buttons.cancel')}
            </Button>
            <Button variant="contained" onClick={onSave} disabled={isLoading}>
                {isLoading ? t('places.states.saving') : t('buttons.save')}
            </Button>
        </DialogActions>
    </Dialog>
);
